module.exports = __webpack_public_path__ + "img/bg_avatar_female_75.0b2a0d9a.png";